import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { me } from '../../initial_state'
import {
  fetchRelatedSuggestions,
} from '../../actions/suggestions'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Account from '../account'
import AccountPlaceholder from '../placeholder/account_placeholder'
import PanelLayout from './panel_layout'
import { SUGGESTION_TYPE_RELATED, SUGGESTION_TYPE_VERIFIED } from '../../constants'

const defaultType = me ? SUGGESTION_TYPE_RELATED : SUGGESTION_TYPE_VERIFIED

class UserSuggestionsPanel extends ImmutablePureComponent {
  state = {
    fetched: !this.props.isLazy
  }

  updateOnProps = ['suggestions', 'isFetched', 'isLazy', 'shouldLoad']

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.shouldLoad && !prevState.fetched) {
      return { fetched: true }
    }

    return null
  }

  render() {
    const { noPanel, isLoading, suggestions, suggestionType, padded } = this.props

    if (suggestions.isEmpty()) return null

    const Child = isLoading ? AccountPlaceholder : Account
    const arr = isLoading ? Array.apply(null, { length: 6 }) : suggestions.sortBy(Math.random)
    const maxCount = 8

    const title =
      suggestionType === SUGGESTION_TYPE_VERIFIED
        ? 'Verified Accounts to Follow'
        : 'Who to Follow'

    return (
      <PanelLayout
        noPanel={noPanel}
        noPadding
        title={title}
        footerButtonTitle={me ? 'Show all' : undefined}
        footerButtonTo={me ? "/suggestions" : undefined}
      >
        <div className={_s.d}>
          {arr && arr.slice(0, maxCount).map(((accountId) => {
            // dont show myself as a suggestion
            if (accountId === me) return null

            return (
              <Child
                compact
                padded={padded}
                key={`suggestion-${accountId}`}
                id={accountId}
                isSmall={isLoading ? true : undefined}
              />
            )
          }))}
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state, { suggestionType }) => {
  if (!suggestionType) suggestionType = defaultType
  return {
    suggestions: state.getIn(['suggestions', suggestionType, 'items']),
    isLoading: state.getIn(['suggestions', suggestionType, 'isLoading']),
    isFetched: state.getIn(['suggestions', suggestionType, 'isFetched']),
  }
}

UserSuggestionsPanel.propTypes = {
  suggestionType: PropTypes.oneOf(['related', 'verified']),
  suggestions: ImmutablePropTypes.list.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLazy: PropTypes.bool
}

UserSuggestionsPanel.defaultProps = {
  suggestionType: defaultType
}

export default connect(mapStateToProps)(UserSuggestionsPanel)
